export default "__VITE_ASSET__DTZHaIrv__"